import posthog from 'posthog-js';

const POSTHOG_KEY = 'phc_BaC6BqQeBwbTCVSXqw4NkaFVqBhLerk5SJ4jLc98LqPe';
const POSTHOG_HOST = 'https://eu.i.posthog.com';
const ANALYTICS_SCHEMA_VERSION = 1;

let currentContext = {};

function durationBucket(durationMs) {
  if (durationMs < 30_000) return '0-30s';
  if (durationMs < 120_000) return '30s-2min';
  if (durationMs < 300_000) return '2-5min';
  return '5min+';
}

function browserContext() {
  return {
    platform: 'web',
    os: navigator.platform || 'unknown',
    browser_language: navigator.language || 'unknown',
  };
}

function compactProperties(properties = {}) {
  return Object.fromEntries(
    Object.entries(properties).filter(([, value]) => value !== undefined && value !== null)
  );
}

export function setAnalyticsContext(context = {}) {
  currentContext = { ...currentContext };
  Object.entries(context).forEach(([key, value]) => {
    if (value === undefined || value === null) delete currentContext[key];
    else currentContext[key] = value;
  });
}

export function initAnalytics() {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: false, // manual pageviews for SPA
    capture_pageleave: true,
    autocapture: false,
    persistence: 'localStorage',
    session_recording: {
      maskAllInputs: true,
    },
    loaded: ph => {
      if (process.env.NODE_ENV === 'development') {
        ph.opt_out_capturing();
      }
    },
  });
}

export function identifyUser(participantId, properties = {}) {
  try {
    posthog.identify(participantId, {
      ...browserContext(),
      analytics_schema_version: ANALYTICS_SCHEMA_VERSION,
      ...currentContext,
      ...compactProperties(properties),
    });
  } catch (_) {}
}

export function capture(event, properties = {}) {
  try {
    posthog.capture(event, {
      analytics_schema_version: ANALYTICS_SCHEMA_VERSION,
      ...browserContext(),
      ...currentContext,
      ...compactProperties(properties),
    });
  } catch (_) {}
}

export function captureDuration(screenName, durationMs, properties = {}) {
  if (!Number.isFinite(durationMs) || durationMs < 0) return;
  capture('screen_time', {
    screen_name: screenName,
    duration_ms: Math.round(durationMs),
    duration_bucket: durationBucket(durationMs),
    ...compactProperties(properties),
  });
}

export function capturePageview(path) {
  try {
    posthog.capture('$pageview', {
      analytics_schema_version: ANALYTICS_SCHEMA_VERSION,
      ...browserContext(),
      ...currentContext,
      $current_url: window.location.origin + path,
    });
  } catch (_) {}
}

export function resetAnalytics() {
  try {
    currentContext = {};
    posthog.reset();
  } catch (_) {}
}

export function captureException(error, context = {}) {
  try {
    posthog.capture('$exception', {
      analytics_schema_version: ANALYTICS_SCHEMA_VERSION,
      ...browserContext(),
      ...currentContext,
      exception_message: error?.message,
      exception_type: error?.name,
      ...compactProperties(context),
    });
  } catch (_) {}
}
